export default __webpack_public_path__ + "static/media/IMG_2745.8a3dd671.JPG";